export class TimeDurationHelpers {
  public static getDisplayDuration(durationInSeconds: number): string {
    if (durationInSeconds === 0) {
      return "0 seconds";
    }

    const durationInMinutes = durationInSeconds / 60;
    if (durationInMinutes < 60) {
      return `${Math.floor(durationInMinutes)} minutes`;
    }

    const durationInHours = durationInMinutes / 60;
    if (durationInHours <= 48) {
      const hours = Math.floor(durationInHours);
      return hours === 1 ? "1 hour" : `${hours} hours`;
    }

    const durationInDays = durationInHours / 24;
    const days = Math.floor(durationInDays);
    return days === 1 ? "1 day" : `${days} days`;
  }
}
